import { Component, Input } from '@angular/core';
import { ChartDataset } from 'chart.js';
import moment from 'moment';
import { DataTableColumn } from 'src/app/shared/components';
import { SessionsWeeklySummaryDto } from 'src/app/shared/dto';

@Component({
    selector: 'app-sessions-card',
    templateUrl: './sessions-card.component.html',
    styleUrls: ['../../../common-reporting-dashboard.scss'],
    standalone: false
})
export class SessionsCardComponent {
    @Input() isShowChart: boolean;
    @Input()
    set sessionSummary(data: SessionsWeeklySummaryDto[]) {
        this._sessionSummary = data;
        this.updateChart();
    };
    get sessionSummaryData(): SessionsWeeklySummaryDto[] {
        return this._sessionSummary;
    }

    sessionsColumns: DataTableColumn[] = [
        {
            dataField: 'weekStart',
            caption: 'Week',
            cellTemplate: 'dateTemplate',
            width: '15%',
            cellClasses: 'border-b-0 pb-1 px-4',
            headerCellClasses: 'py-1',
            dateFormat: 'MM/dd/yy'
        },
        {
            dataField: 'revdriverSessionCount',
            caption: 'RevDriver Logins',
            cellTemplate: 'numberTemplate',
            width: '30%',
            allowSorting: false,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',

        },
        {
            dataField: 'portalSessionCount',
            caption: 'Web App Logins',
            cellTemplate: 'numberTemplate',
            width: '30%',
            allowSorting: false,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',
        },
        {
            dataField: 'totalSessionCount',
            caption: 'Total Logins',
            cellTemplate: 'numberTemplate',
            width: '25%',
            allowSorting: false,
            cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
            headerCellClasses: 'py-1 text-center',
        },
    ];

    chartLabels: string[] = []
    stackChartData: ChartDataset<'bar'>[] = [];

    private _sessionSummary: SessionsWeeklySummaryDto[];

    updateChart(): void {
        if (this._sessionSummary && this._sessionSummary.length > 0) {
            this.chartLabels = this._sessionSummary.map(entry => moment(entry.weekStart, 'YYYY-MM-DD').format('MM/DD/YY').toString());

            const portalSessionData = this._sessionSummary.map(entry => entry.portalSessionCount);
            const revdriverSessionData = this._sessionSummary.map(entry => entry.revdriverSessionCount);

            this.stackChartData = [
                {
                    label: 'Web App',
                    data: portalSessionData,
                    backgroundColor: '#3F6BB4'
                },
                {
                    label: 'RevDriver',
                    data: revdriverSessionData,
                    backgroundColor: '#FF994E'
                }
            ];
        }
    }

}
